import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import { Stack, Menu, MenuItem, Avatar, Button } from "@mui/material";
import SalesReport from "../Assets/images/SalesReport.png";

import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import SiteLogo from "../Assets/images/siteLogoWhite.svg";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

import {
  rSetCompanyAddress,
  rSetCompanyCountry,
  rSetCompanyId,
  rSetCompanyName,
  rSetCompanyState,
} from "../../redux/reducers/GlobalVariables";

import { useDispatch, useSelector } from "react-redux";
import configServ from "../../services/config";
import { assignType } from "../../redux/reducers/Admin";
import SiteLogoInitial from "../Assets/images/SiteIcon.svg";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import LogoutIcon from "@mui/icons-material/Logout";
import Logout from "../Logout/Logout";
import YesNoDialog from "../AlertDialog/YesNoDialog";
import VoiceCommand from "../VoiceRecognization/VoiceCommand ";
import NotificationBell from "./NotificationBell/NotificationBell";

// icon
import InventoryIcon from "@mui/icons-material/Inventory";
import CategoryIcon from "@mui/icons-material/Category";
import AndroidIcon from "@mui/icons-material/Android";
import ReceiptIcon from "@mui/icons-material/Receipt";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import GroupsIcon from "@mui/icons-material/Groups";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import ExtensionIcon from "@mui/icons-material/Extension";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import Diversity1Icon from "@mui/icons-material/Diversity1";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import MarkUnreadChatAltIcon from "@mui/icons-material/MarkUnreadChatAlt";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import PhonelinkSetupIcon from "@mui/icons-material/PhonelinkSetup";
import ApartmentIcon from "@mui/icons-material/Apartment";
import EditLocationAltIcon from "@mui/icons-material/EditLocationAlt";
import BadgeIcon from "@mui/icons-material/Badge";
import AppsOutageIcon from "@mui/icons-material/AppsOutage";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import CommentIcon from "@mui/icons-material/Comment";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import LocalCarWashIcon from "@mui/icons-material/LocalCarWash";
import ReportIcon from "@mui/icons-material/Report";
import ContactlessIcon from "@mui/icons-material/Contactless";
// import ReceiptIcon from '@mui/icons-material/Receipt';
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import BrowserUpdatedIcon from "@mui/icons-material/BrowserUpdated";
import PaidIcon from "@mui/icons-material/Paid";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { motion, AnimatePresence } from "framer-motion";
import { Tooltip } from "@mui/material";
import Zoom from "@mui/material/Zoom";
import { LoaderIcon } from "react-hot-toast";
import LoaderNew from "../Loader/LoaderNew";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import PortableWifiOffIcon from '@mui/icons-material/PortableWifiOff';
import DevicesFoldIcon from '@mui/icons-material/DevicesFold';

const drawerWidth = 240;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const CustomAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  backgroundColor: "#555", // Match sidebar background
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

// FUNCTION
const SideBarRedesign = () => {
  //#region code
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [expandedSection, setExpandedSection] = React.useState(null);
  const [activeItem, setActiveItem] = React.useState(null);
  const [activeSubItem, setActiveSubItem] = React.useState(null); // Track active subcategory
  const menuRef = useRef(null);

  // header wala copy past
  const { user_id, company_id, companyName, is_super, is_admin, permissions } =
    useSelector((state) => state.GlobalVariables);
  const dispatch = useDispatch();
  const [companyLogo, setCompanyLogo] = useState("");
  const [companyList, setCompanyList] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const navigate = useNavigate();
  const [companySwitchPopup, setCompanySwitchPopup] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open1 = Boolean(anchorEl);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const open2 = Boolean(anchorEl2);
  const NavToolTip = ({ text, children }) => {
    return (
      <Tooltip
        TransitionComponent={Zoom}
        leaveDelay={200}
        title={text}
        placement="right"
        arrow
        sx={{ fontSize: "16px" }}
      >
        {children}
      </Tooltip>
    );
  };
  const handleMenuItemClick = (item) => {
    setActiveItem(item); // Set the active item when clicked
  };

  const handleSubItemClick = (subItem) => {
    setActiveSubItem(subItem); // Set the active subcategory when clicked
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleSectionClick = (section) => {
    setExpandedSection((prevSection) =>
      prevSection === section ? null : section
    );
  };

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  }));

  const StyledIconButton = styled(IconButton)(({ theme }) => ({
    color: "white", // Icon color
    fontSize: "2rem", // Increase icon size
    fontWeight: "bold", // Make icon bold
  }));

  const handleMenuItemClickAndClose = (item) => {
    handleMenuItemClick(item);
    setExpandedSection(null); // Close all expanded sections
    setOpen(false); // Close the sidebar
  };

  const handleSubItemClickAndClose = (subItem) => {
    handleSubItemClick(subItem);
    setOpen(false); // Close the sidebar
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // header wala function sab
  const assignCompanyLogo = async () => {
    try {
      const result = await configServ.company_logo({ company_id: company_id });
      if (result.image) {
        setCompanyLogo(`data:image/png;base64,${result.image}`);
      } else {
        setCompanyLogo("");
      }
    } catch (e) {
      console.log(e);
    }
  };

  const fetchCompanyList = async () => {
    try {
      const result = await configServ.getCompanyList({ user_id: user_id });
      setCompanyList(result);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchCompanyList();
    assignCompanyLogo();
  }, []);

  const switchCompany = async () => {
    dispatch(rSetCompanyId(companyData.id));
    const data = {
      id: companyData.id,
    };

    const res = await configServ.getCompanyById(data);
    if (res.status === 200) {
      dispatch(rSetCompanyName(res.data.CompanyName));
      dispatch(rSetCompanyAddress(res.data.Address));
      dispatch(rSetCompanyCountry(res.data.country));
      dispatch(rSetCompanyState(res.data.State));
    }
    //localStorage.setItem('company_type', companyData.CompanyType);
    dispatch(assignType(companyData.CompanyType));
    const dataToSend = {
      user_id: user_id,
      company_id: companyData.id,
    };
    try {
      const result = await configServ.setActiveCompany(dataToSend);
    } catch (e) {
      console.log(e);
    }
    navigate(0);
  };

  const handleCompanySwitchPopup = () => {
    setCompanySwitchPopup(!companySwitchPopup);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  function stringAvatar(name) {
    const initials = name
      ? name.includes(" ")
        ? `${name.split(" ")[0][0].toUpperCase()}${name
            .split(" ")[1][0]
            .toUpperCase()}`
        : `${name[0].toUpperCase()}`
      : "W";

    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: initials,
    };
  }

  function stringToColor(string) {
    // Return a default color if the input string is undefined or null
    if (!string) {
      return "#000000"; // You can choose any default color you prefer
    }

    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }

  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const handleLogout = () => {
    setIsLogutDialogOpen(!isLogutDialogOpen);
  };

  const [isLogutDialogOpen, setIsLogutDialogOpen] = useState(false);
  const [expandedMenu, setExpandedMenu] = React.useState(null); // Track expanded menu
  const [menus, setMenus] = React.useState([]);

  const handleMenuClick = (menu) => {
    if (menu.submenus.length === 0) {
      navigate(menu.routes); // Navigate directly
      setOpen(false);
    } else {
      setExpandedMenu(expandedMenu === menu.id ? null : menu.id); // Toggle submenu
    }
  };

  const handleSubmenuClick = (route) => {
    navigate(route);
    setOpen(false);
  };

  const [loading, setLoading] = useState(false);

  const fetchMenuList = async () => {
    setLoading(true);
    try {
      const res = await configServ.getActiveMenusWithSubmenus();
      if (res.status === 200 && Array.isArray(res.data)) {
        setMenus(res.data || []);
      } else {
        setMenus([]);
        // toast.error("Failed to fetch menu list.");
      }
    } catch (e) {
      // toast.error("An error occurred!");
      console.log(e);
      setMenus([]);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchMenuList();
  }, []);

  // Icon mapping object
  const iconMapping = {
    dashboard: <DashboardIcon />,
    inventory: <InventoryIcon />,
    brand: <AndroidIcon />,
    category: <CategoryIcon />,
    invoice: <ReceiptIcon />,
    subscriptions: <SubscriptionsIcon />,
    sales: <AddShoppingCartIcon />,
    group: <GroupsIcon />,
    unit: <AcUnitIcon />,
    item: <ExtensionIcon />,
    hsn: <AutoAwesomeMotionIcon />,
    super: <SupervisedUserCircleIcon />,
    location: <AddLocationAltIcon />,
    catalog: <CastForEducationIcon />,
    customers: <Diversity1Icon />,
    lead: <LeaderboardIcon />,
    account: <Diversity3Icon />,
    master: <FamilyRestroomIcon />,
    supplier: <PrecisionManufacturingIcon />,

    transaction: <ContactlessIcon />,
    cashvoucher: <ReceiptIcon />,
    journal: <ReceiptLongIcon />,
    gst: <AccountBalanceWalletIcon />,
    stockupdate: <BrowserUpdatedIcon />,
    puchaseorder: <ShoppingBasketIcon />,
    purchasebill: <PaidIcon />,
    dispatch: <LocalCarWashIcon />,
    reports: <ReportIcon />,
    outstanding: <AppsOutageIcon />,
    gstreport: <CommentIcon />,
    salesreport: <ForwardToInboxIcon />,
    salessummary: <AssessmentIcon />,
    salessummary2: <AttachEmailIcon />,
    trial: <AssuredWorkloadIcon />,
    ledger: <BadgeIcon />,
    loghistory: <EditLocationAltIcon />,
    companyregister: <ApartmentIcon />,
    configuration: <PhonelinkSetupIcon />,
    profile: <AccountBoxIcon />,
    unregister: <MarkUnreadChatAltIcon />,
    accessmaster: <VpnKeyIcon />,
    menupermission: <GppMaybeIcon />,
    salescancel: <PortableWifiOffIcon/>,
    invoicecancel: <DevicesFoldIcon/>

  };
  const getIcon = (iconName) => {
    return iconMapping[iconName.toLowerCase()] || null; // Return null if icon doesn't exist
  };

    // permission
  // Function to filter menus based on permissions
  const filterMenus = (menus) => {
    if (is_admin || is_super) return menus; // Show all menus if is_admin or is_super is true

    return menus
      .map((menu) => {
        // Check menu permission
        const hasMenuPermission = permissions.includes(menu.permission);

        // Filter submenus based on their permissions
        const filteredSubmenus = menu.submenus.filter((submenu) =>
          submenu.permission ? permissions.includes(submenu.permission) : false
        );

        // Include menu if it has permission or has filtered submenus
        if (hasMenuPermission || filteredSubmenus.length > 0) {
          return { ...menu, submenus: filteredSubmenus };
        }
        return null;
      })
      .filter((menu) => menu !== null); // Remove menus that don't have permission and no valid submenus
  };

  // Get filtered menus
  const filteredMenus = filterMenus(menus);

  //#endregion

  return (
    <>
      <Logout open={isLogutDialogOpen} setOpen={setIsLogutDialogOpen} />
      <YesNoDialog
        open={companySwitchPopup}
        setOpen={setCompanySwitchPopup}
        title={"Company Switch"}
        message={"Do you want to switch company?"}
        handleYes={switchCompany}
      />
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <CustomAppBar
          position="fixed"
          open={open}
          sx={{ backgroundColor: "white", color: "black" }} // White header with black text
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{ mr: 2, ...(open && { display: "none" }) }}
            >
              <MenuIcon sx={{ color: "black" }} /> {/* Black icon */}
            </IconButton>
            {/* Replacing the Typography with the company logo/name logic */}
            <Stack maxWidth={1000} height="100%" justifyContent="center">
              <IconButton
                maxWidth={1000}
                id="basic-button"
                aria-controls={open1 ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={is_super === 1 ? handleClick : () => {}}
              >
                {companyLogo === "" ? (
                  <Typography
                    variant="button"
                    sx={{
                      p: 1,
                      fontSize: { xs: "12px", md: "16px" },
                      fontWeight: 700,
                      color: "black",
                      ":hover": {
                        color: "grey",
                      },
                    }}
                  >
                    {companyName}
                  </Typography>
                ) : (
                  <Box
                    component="img"
                    src={companyLogo || SiteLogoInitial}
                    alt="logoInitial"
                    height="50"
                    title={companyName}
                    sx={{
                      borderRadius: "50%", // This makes the image circular
                      width: "50px", // Ensure width matches height for a perfect circle
                      objectFit: "cover", // Ensures the image scales correctly inside the circle
                    }}
                  />
                )}
              </IconButton>

              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open1}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                {companyList
                  .sort((a, b) => a.CompanyName.localeCompare(b.CompanyName))
                  .map((item) => (
                    <MenuItem
                      key={item.id}
                      sx={{
                        padding: { xs: 1, md: 2 },
                        height: { xs: "2.5rem", md: "3.5rem" },
                        fontWeight: 600,
                      }}
                      onClick={() => {
                        handleClose();
                        setCompanyData(item);
                        handleCompanySwitchPopup();
                      }}
                    >
                      {item.CompanyLogo === null || item.CompanyLogo === "" ? (
                        <span style={{ color: "#1e61b4" }}>
                          {item.CompanyName}
                        </span>
                      ) : (
                        <>
                          <img
                            style={{ padding: "5px" }}
                            src={`data:image/png;base64,${item.CompanyLogo}`}
                            alt={item.CompanyName}
                            width="50"
                          />
                          <span style={{ color: "#1e61b4" }}>
                            {item.CompanyName}
                          </span>
                        </>
                      )}
                    </MenuItem>
                  ))}
              </Menu>
            </Stack>

            <Box sx={{ flexGrow: 1 }} />
            <Stack
              direction="row"
              spacing={4} // Adds space between avatar and bell
              alignItems="center"
              marginRight={-7} // Adjust the right margin as needed
            >
              <VoiceCommand />
              <NotificationBell />

              <IconButton
                id="basic-button2"
                aria-controls={open2 ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open2 ? "true" : undefined}
                onClick={handleClick2}
                sx={{
                  width: "5%",
                  // px: 7,
                  //backgroundColor: 'rgba(0, 0, 0, 0.08)',
                  borderRadius: "20px",
                  cursor: "pointer",
                  ":hover": {
                    //backgroundColor: 'rgba(0, 0, 0, 0.16)',
                  },
                }}
              >
                <Avatar {...stringAvatar(companyName)} />
                {anchorEl2 === null ? (
                  <ArrowDropDownIcon
                    sx={{ marginRight: 1, fontSize: "30px" }}
                  />
                ) : (
                  <ArrowDropUpIcon
                    sx={{ marginRight: 1, fontSize: "30px" }}
                    color="primary"
                  />
                )}
                {/* <SettingsIcon  */}
              </IconButton>
            </Stack>
            {/* profile menu */}
            <Menu
              id="basic-menu2"
              anchorEl={anchorEl2}
              open={open2}
              onClose={handleClose2}
              MenuListProps={{
                "aria-labelledby": "basic-button2",
              }}
            >
              <Link style={{ textDecoration: "none" }} to="/profile">
                <MenuItem onClick={handleClose2} sx={{ padding: 0 }}>
                  <Button
                    sx={{ color: "black", padding: 2 }}
                    startIcon={<AccountBoxIcon />}
                  >
                    My Profile
                  </Button>
                </MenuItem>
              </Link>
              <MenuItem
                onClick={() => {
                  handleClose2();
                  handleLogout();
                }}
                sx={{ padding: 0 }}
              >
                <Button
                  sx={{ color: "black", padding: 2 }}
                  startIcon={<LogoutIcon />}
                >
                  Log Out
                </Button>
              </MenuItem>
            </Menu>
          </Toolbar>
        </CustomAppBar>

        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              backgroundColor: "#555", // Sidebar background
              color: "white", // Text color
            },
          }}
          variant="persistent"
          anchor="left"
          open={open}
          ref={menuRef}
        >
          <DrawerHeader>
            <img
              src={SiteLogo}
              alt="logo"
              width="150"
              hidden={open ? false : true}
            />
            <StyledIconButton onClick={handleDrawerClose}>
              {theme.direction === "ltr" ? (
                <ChevronLeftIcon sx={{ color: "white" }} />
              ) : (
                <ChevronRightIcon sx={{ color: "white" }} />
              )}
            </StyledIconButton>
          </DrawerHeader>
          <Divider />

          {/* Iterate Menus */}
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <LoaderNew /> {/* Replace with your loader icon/component */}
            </div>
          ) : (
            <>
              {filteredMenus.map((menu) => (
                <div key={menu.id}>
                  {/* Main Menu */}
                  <div
                    onClick={() => handleMenuClick(menu)}
                    style={{
                      cursor: "pointer",
                      padding: "10px",
                      color: "white",
                      display: "flex",
                      justifyContent: open ? "space-between" : "center",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px", // Add spacing between icon and name
                      }}
                    >
                      <NavToolTip text={menu.name}>
                        {getIcon(menu.icon)}
                      </NavToolTip>{" "}
                      {open && menu.name}
                    </span>
                    {menu.submenus.length > 0 &&
                      (expandedMenu === menu.id ? (
                        <ArrowDropUpIcon />
                      ) : (
                        <ArrowDropDownIcon />
                      ))}
                  </div>

                  {/* Submenus */}
                  <AnimatePresence>
                    {expandedMenu === menu.id && menu.submenus.length > 0 && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                      >
                        <ul style={{ listStyle: "none", paddingLeft: "20px" }}>
                          {menu.submenus.map((submenu) => (
                            <li key={submenu.id}>
                              <div
                                onClick={() =>
                                  handleSubmenuClick(submenu.routes)
                                }
                                style={{
                                  cursor: "pointer",
                                  padding: "8px",
                                  color: "white",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "12px", // Add spacing for submenu items
                                }}
                              >
                                <NavToolTip text={submenu.name}>
                                  {getIcon(submenu.icon)}
                                </NavToolTip>
                                {open && submenu.name}{" "}
                                {/* Only show name if sidebar is open */}
                              </div>
                            </li>
                          ))}
                        </ul>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              ))}
            </>
          )}
        </Drawer>
      </Box>
    </>
  );
};

export default SideBarRedesign;
